import Link from '@carvana/ds-link';
import Skeleton from '@carvana/ds-skeleton';
import cx from 'classnames';
import { useContext } from 'react';
import { useGetCtaWrapperContent } from '@/vdp/CtaWrapper';
import { useAnalyticsId } from '~/context/vdp/SectionAnalyticsContext';
import VehicleContext, {
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import useGetSimilarVehicleCount from './hooks/useGetSimilarVehicleCount';

export default function UnavailableHeroContent() {
  const {
    similarVehicleCount: { data: similarVehicleCount, isLoaded, hasError }
  } = useContext(VehicleContext);
  const { make = '', parentModel = '' } = useGetVehicleDetails();
  const { content } = useGetCtaWrapperContent();
  const analyticsId = useAnalyticsId();
  const removeLink = hasError || similarVehicleCount === 0;
  const searchHref = generateSearchLinkFilter({
    filters: { makes: [{ name: make, parentModels: [{ name: parentModel }] }] }
  });

  useGetSimilarVehicleCount();

  return (
    <>
      {content?.title && (
        <div className="text-text-strong t-heading-lg sm:t-heading-2xl">
          {content.title}
        </div>
      )}
      {isLoaded ? (
        <Link
          href={searchHref}
          className={cx('no-underline', removeLink ? 'hidden' : '')}
          data-adobe-id="similar-vehicles-link"
          data-analytics-id={analyticsId}
          data-analytics-attributes={JSON.stringify({
            description: 'view other options',
            text: `View all ${similarVehicleCount.toLocaleString()} ${make} ${parentModel} in stock`
          })}
          data-testid="similar-vehicles-link"
          preventVisitedColor
        >
          We’ve got {similarVehicleCount.toLocaleString()} other {make}{' '}
          {parentModel} in stock
        </Link>
      ) : (
        <Skeleton height="24px" width="300px" />
      )}
    </>
  );
}
